module.exports = __webpack_public_path__ + "img/ticket_ko1.f9730558.png";